import { Component, HostBinding, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

import { UnitEditModel } from '../../../models';

import { UnitService } from '../../../services';

import { AppUtils, RoleMatrix } from '../../../helpers';

@Component({
    selector: 'app-unit-edit',
    templateUrl: './unit.edit.component.html'
})

export class UnitEditComponent implements OnInit {
    roleMatrix: RoleMatrix;
    @HostBinding('class.full_width') full_width = true;
    @BlockUI('container-blockui') blockUI: NgBlockUI;

    model: UnitEditModel = new UnitEditModel();

    constructor(private router: Router,
        private route: ActivatedRoute,
        private toastr: ToastrService,
        private unitService: UnitService,
        private appUtils: AppUtils) {
        this.roleMatrix = new RoleMatrix();

        if (!this.roleMatrix.canEditFacility) {
            this.router.navigate(['/error/403']);

        }
        this.route.params.subscribe((params) => {
            this.model.companyId = params['companyId'];
            this.model.facilityId = params['facilityId'];
            this.model.id = params['id'];
        });

        if (!this.roleMatrix.is10FedUser
            && this.roleMatrix.companyId !== this.model.companyId.toString()) {
            this.router.navigate(['/error/404']);
        }
    }

    ngOnInit() {
        this.blockUI.start();
        this.unitService.getForEdit(this.model.id).subscribe(
            (data) => {
                this.blockUI.stop();
                Object.assign(this.model, data);
                if (this.model.status === 3) {
                    this.router.navigate(['/error/404']);
                }
            },
            error => {
                this.blockUI.stop();
                this.appUtils.ProcessErrorResponse(this.toastr, error);
            });
    }

    submit() {
        this.blockUI.start();
        this.unitService.edit(this.model)
            .subscribe(
                () => {
                    this.blockUI.stop();
                    setTimeout(() => {
                        this.router.navigate(['/unit/detail/', this.model.companyId, this.model.facilityId, this.model.id]);
                    }, 10);
                    setTimeout(() => {
                        this.toastr.success('Unit has been updated successfully');
                    }, 100);
                },
                error => {
                    this.blockUI.stop();
                    this.appUtils.ProcessErrorResponse(this.toastr, error);
                });
    }
}
